export const PAGE_COMPONENT_KEY = 'components';
export const COMPONENT_CHILDREN_KEY = 'children';
